import React, { useState } from 'react';
import { VisibilityOutlined as PreviewIcon } from '@mui/icons-material';
import { downloadCsv } from '../../utils/exportUtils';

/**
 * Preview-before-Download for any CSV export (Invoices, Purchases, Gate Passes, Customers,
 * GD register, Cash/Checks/Pay Orders, Products, Exchange Rates, Batches, Expenses...).
 * Added 2026-09-14 per explicit long-standing request — every "Export CSV" button used to
 * download straight away with no way to check what's actually in the file first.
 *
 * Takes the data already shaped as {headers, matrix} (see utils/exportUtils.js's buildXxxRows
 * helpers, or a locally-built one) — this component never re-fetches anything, it just renders
 * what's already in memory and only writes to disk when Download is explicitly clicked.
 */
const CsvActions = ({ label = 'Export CSV', filename, headers, matrix, className = 'btn-secondary', style }) => {
  const [open, setOpen] = useState(false);
  if (!matrix || matrix.length === 0) return null;

  const doDownload = () => downloadCsv(filename, headers, matrix);

  return (
    <span style={{ display: 'inline-flex', gap: 6, ...style }}>
      <button className={className} onClick={() => setOpen(true)}>
        <PreviewIcon sx={{ fontSize: 16 }} aria-hidden="true" /> Preview
      </button>
      <button className={className} onClick={doDownload}>{label}</button>
      {open && (
        <div className="modal-overlay" onClick={() => setOpen(false)} style={{ zIndex: 2000 }}>
          <div className="modal-content" style={{ maxWidth: 960, width: '92%', maxHeight: '82vh', display: 'flex', flexDirection: 'column' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 style={{ margin: 0 }}>{label} Preview — {matrix.length.toLocaleString()} row{matrix.length === 1 ? '' : 's'}</h3>
              <button className="modal-close" onClick={() => setOpen(false)}>&times;</button>
            </div>
            <div style={{ overflow: 'auto', padding: '0 4px', flex: 1 }}>
              <table className="data-table" style={{ fontSize: 12 }}>
                <thead>
                  <tr>{headers.map((h, i) => <th key={i}>{h}</th>)}</tr>
                </thead>
                <tbody>
                  {matrix.slice(0, 200).map((row, i) => (
                    <tr key={i}>{row.map((cell, j) => <td key={j}>{cell === '' || cell == null ? '—' : String(cell)}</td>)}</tr>
                  ))}
                </tbody>
              </table>
              {matrix.length > 200 && (
                <div style={{ padding: 10, color: 'var(--color-text-tertiary)', fontSize: 12 }}>
                  Showing the first 200 of {matrix.length.toLocaleString()} rows — download for the complete file.
                </div>
              )}
            </div>
            <div style={{ padding: '12px 16px', display: 'flex', justifyContent: 'flex-end', gap: 8, borderTop: '1px solid var(--color-border-medium)' }}>
              <button className="btn-secondary" onClick={() => setOpen(false)}>Close</button>
              <button className="btn-primary" onClick={doDownload}>Download CSV</button>
            </div>
          </div>
        </div>
      )}
    </span>
  );
};

export default CsvActions;
